import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { KeyboardDatePicker } from 'seagull';
const toFromErrorMessage = 'To date must be after from date';
const DateRangePicker = (param)=>{
    let { fromDate, toDate, testId, dateLimits = {}, onChange, onInputBlur, onInputFocus } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                label: "From",
                testId: testId && "".concat(testId, "-from"),
                value: fromDate,
                minDate: dateLimits.min,
                maxDate: toDate,
                minDateMessage: dateLimits.minDateMessage,
                maxDateMessage: toFromErrorMessage,
                onChange: (date)=>date && onChange({
                        fromDate: date,
                        toDate
                    }),
                onFocus: onInputFocus,
                onBlur: onInputBlur
            }),
            /*#__PURE__*/ _jsx(KeyboardDatePicker, {
                label: "To",
                testId: testId && "".concat(testId, "-to"),
                value: toDate,
                minDate: fromDate,
                maxDate: dateLimits.max,
                minDateMessage: toFromErrorMessage,
                maxDateMessage: dateLimits.maxDateMessage,
                onChange: (date)=>date && onChange({
                        fromDate,
                        toDate: date
                    }),
                onFocus: onInputFocus,
                onBlur: onInputBlur
            })
        ]
    });
};
export default DateRangePicker;
